import {
  Badge,
  type BadgeProps,
  Box,
  Button,
  type ButtonProps,
  type ComponentWithAs,
  forwardRef,
} from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { useCollapsiblePanel } from "@src/components/ui-kit/CollapsiblePanel/CollapsiblePanel";
import { Icon } from "@src/components/ui-kit/Icon";
import { type FC, useMemo } from "react";

export const FilterCountBadge: FC<BadgeProps> = (props) => (
  <Badge
    alignItems="center"
    colorScheme="red"
    display="inline-flex"
    h="4"
    justifyContent="center"
    minW="4"
    px="1"
    py="0"
    size="sm"
    {...props}
  />
);

export const MoreFiltersButton: ComponentWithAs<
  "button",
  Omit<ButtonProps, "children"> & {
    appliedCount?: number;
    templateName?: string;
  }
> = forwardRef(({ appliedCount = 0, templateName, ...props }, ref) => {
  const { visibleItems } = useCollapsiblePanel();

  const allFiltersCollapsed = useMemo(
    () => visibleItems.length === 0,
    [visibleItems],
  );

  return (
    <Box display="inline-flex" position="relative">
      <Button
        ref={ref}
        colorScheme="grey"
        rightIcon={<Icon name="chevron-down" />}
        variant={appliedCount > 0 ? "outline" : "ghost"}
        {...props}
      >
        {templateName
          ? t`Filters: ${templateName}`
          : allFiltersCollapsed
            ? t`Filters`
            : t`More Filters`}
      </Button>
      {appliedCount > 0 && (
        <FilterCountBadge
          pointerEvents="none"
          position="absolute"
          right="0"
          top="0"
          transform="translate(50%, -50%)"
        >
          {appliedCount}
        </FilterCountBadge>
      )}
    </Box>
  );
});
